export default "__VITE_ASSET__9318ab6a__"